import type { FC, SetStateAction } from "react";
import React from "react";

import { useGetPatientPerioquiz } from "@/api/patients";
import DialogCustom from "@/components/modals/dialog-custom";
import PerioquizCard from "@/components/perioquiz/perioquiz-card";
import Loader from "@/components/ui/loader";
import { Separator } from "@/components/ui/separator";
import type { Patient } from "@/types/api/patient";
import type { Perioquiz } from "@/types/api/perioquiz";

interface PerioquizListSideModalProps {
  patient: Patient;
  open: boolean;
  onOpenChange: React.Dispatch<SetStateAction<boolean>>;
  onSelect: (selected: Perioquiz) => void;
}

const PerioquizListSideModal: FC<PerioquizListSideModalProps> = ({
  patient,
  open,
  onOpenChange,
  onSelect,
}) => {
  const { data, isLoading } = useGetPatientPerioquiz(patient.id);

  return (
    <DialogCustom
      title="Perioquiz"
      description={
        <div className="text-sm text-gray-600">{"Réponses au Perioquiz"}</div>
      }
      open={open}
      onOpenChange={onOpenChange}
      side
      className="pb-0"
    >
      <Separator />
      {isLoading || !data ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-5 p-8 bg-grey-25">
          {data.map((perioquiz) => (
            <PerioquizCard
              key={perioquiz.id}
              perioquiz={perioquiz}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </DialogCustom>
  );
};

export default PerioquizListSideModal;
